// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__35RG5","footer":"Form_footer__32woB"};